'use strict';

(function ($window, addIntersectionEvent, options, observedItems, observationCallback) {
    var boundObs = observationCallback.bind(undefined, observedItems);

    $window.addEventListener(addIntersectionEvent, function ($event) {
        var detail = $event.detail;
        var observer = void 0;

        if (detail && detail.target && detail.callback) {
            var target = detail.target;

            if (detail.options) {
                observer = new IntersectionObserver(boundObs, detail.options);
            } else if (observer == undefined) {
                observer = new IntersectionObserver(boundObs, options);
            }

            if (target instanceof HTMLElement) {
                observer.observe(target);
                observedItems.push(detail);
                return;
            }

            if (target instanceof NodeList) {
                [].forEach.call(target, function (t) {
                    observer.observe(t);
                    observedItems.push({
                        target: t,
                        callback: detail.callback
                    });
                });
                return;
            }

            if (typeof target === 'string') {
                [].forEach.call($window.document.querySelectorAll(target), function (t) {
                    observer.observe(t);
                    observedItems.push({
                        target: t,
                        callback: detail.callback
                    });
                });
                return;
            }
        }
    });
})(window, 'add-intersection', { threshold: .01 }, [], function (observedItems, $events) {
    return $events.forEach(function ($event) {
        return observedItems.filter(function (item) {
            return item.target === $event.target;
        }).forEach(function (item) {
            return item.callback({
                target: $event.target,
                isInView: $event.isIntersecting,
                intersectionRatio: $event.intersectionRatio
            });
        });
    });
});